/* 
 * This script loads foundation tabs components
 * 
 * Requires: 
 *	- jQuery
 *	- foundation.core.js
 *	- foundation.util.keyboard.js
 *	- foundation.util.timerAndImageLoader
 *	- foundation.tabs
 *	
 *	Author: Michael Kohler <michael.kohler@somedia.ch>
 */

// Requires
var $ = require('jquery');
require('foundation-sites');
require('jquery.cookie');
	
// Modul construct
var somModul = {
	
	// Module name
	name: 'foundation.tabs',
	
	// Cookie name to store active states
	cookieName: 'tx_somdistribution_activetabs',
	
	// Store active tabs
	activeTabs: [],
		
	// Container
	container: null,
	
	/*
	 * Init function
	 * 
	 * @return void
	 */
	init: function() {
		
		// Get component config
		var componentConfig = this.__getComponentConfig(somModul.name);

		// Set container
		somModul.container = $('.tabs'); 
		
		if(componentConfig.enabled && somModul.container.length != 0){
			
			// Load active tabs from cookie
			somModul.loadActiveTabs();
			
			somModul.container.each(function(index) {
				
				var $tabMenuContainer = $(this);
				if($tabMenuContainer.find('.tabs-title.is-active').length == 0) {
					somModul.setActiveTab($tabMenuContainer, index);
				}
				
				// Init foundation tab menu
				var tabMenu = new Foundation.Tabs($tabMenuContainer);
				
				// Event handler on tab change to store active tab in cookie
				$tabMenuContainer.on('change.zf.tabs', function(event, tab) {
					somModul.activeTabs[index] = tab.index();
					somModul.storeActiveTabs();
				});
			});
				
			return true;
		}
	},
	
	/*
	 * Set active tab by cookie data. if not available, 
	 * set fist active
	 * 
	 * @param {jQuery} $tabMenuContainer The tab menu container
	 * @param int index The current tab element index
	 * @return void
	 */
	setActiveTab: function($tabMenuContainer, index) {
		
		// Set tab active
		if(typeof somModul.activeTabs[index] == 'number') {
			var $activeTab = $tabMenuContainer.find('.tabs-title').eq(somModul.activeTabs[index]);
		} else {
			var $activeTab = $tabMenuContainer.find('.tabs-title:first-child');
		}		
		
		// Set corresponding panel active
		if($activeTab.length == 1) {
			
			// modify tab
			$activeTab.addClass('is-active');
			var $tabLink =  $activeTab.find('> a');
			$tabLink.attr('aria-selected', 'true');
			
			// Modify panel
			var panelId = $tabLink.attr('href');
			$(panelId).addClass('is-active');
		}
	},
	
	/*
	 * Load active tabs from cookie
	 * 
	 * @return void
	 */
	loadActiveTabs: function() {
		
		var cookieData = $.cookie(somModul.cookieName);
		if(typeof cookieData != 'undefined') {
			somModul.activeTabs = JSON.parse(cookieData);
		}
	},
	
	/*
	 * Store active tabs from cookie
	 * 
	 * @return void
	 */
	storeActiveTabs: function() {
		$.cookie(somModul.cookieName, JSON.stringify(somModul.activeTabs));
	}
};

// Return modul construct - commonJS syntax
module.exports = somModul;


/** WEBPACK FOOTER **
 ** ./src/components/foundation.tabs.js
 **/